import getBackground, {
  backgroundOptions as backgroundOptionsArray,
} from "./Backgrounds";
export const backgroundOptions = backgroundOptionsArray;
export default getBackground;
